export default __webpack_public_path__ + "static/media/download.3b6a3d8d.svg";